export default "__VITE_ASSET__B4XxtM_g__"